{% block sw_order_detail_base_secondary_info_order_overview_right_column_slot %}
    {% parent %}

    {% block sw_detail_base_secondary_info_order_overview_paypal_carrier %}
    <template v-if="payPalResourceId">
        <dt>
            {{ $t('sw-order-detail.payPalCarrierLabel') }}
            <sw-help-text :text="$t('sw-order-detail.payPalCarrierHelpText')" />
        </dt>

        <dd>
            <div>
                {{ payPalCarrier ? payPalCarrier : $t('sw-order-detail.payPalCarrierPlaceholder') }}
            </div>

            <div
                class="sw-user-card__paypal-carrier-description"
                v-html="payPalCarrierDescription"
            />
        </dd>
    </template>
    {% endblock %}

{% endblock %}
